// import '../../Styles/css/Day.css';
// import '../../Styles/css/Counter.css';

import './DayCalendrier.scss';

import { Tooltip } from '@mui/material';
//import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EmplacementEnum, fluxCandidature, rdvStatus } from '../../data/Interfaces';
import useCraRdv from '../../hooks/useCraRdv';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue, statuRDV2ClassName } from '../../Utils/utils';

export default function DayCalendrier({ day, rowIdx, evts }) {

    DayCalendrier.propTypes = {
        day: PropTypes.any,
        rowIdx: PropTypes.any,
        evts: PropTypes.any,
    };

    const [dayEvent, setDayEvent] = useState([]);
    const { i18n } = useTranslation();
    const {   setShowRDV,   setSelectedRDV,  setOpenNestedInterviewerCandidature  } = useCraRdv();
    const {device}=useWindowSize();
    let list = [];
    const role = useRole();

    //========================================useEffect=======================================
    useEffect(() => {
        if(evts){
            evts.map((ev) => {
                if (ev.date.split(' ')[0] === day.format('DD-MM-YYYY')) list.push(ev);
            });
            setDayEvent(list);
        }
    }, [evts, day]);

    //function getCurrentDayClass() {
    //    return day.format('DD-MM-YY') === dayjs().format('DD-MM-YY')
    //        ?
    //        {backgroundColor: '#2563EB',
    //            color: '#ffffff',
    //            borderRadius: '9999px',}
    //        : {};
    //}

    function getInfoRdv(evt) {
        return (
            `${i18n.t('Titre')}: ` + (evt?.candidatureId?.aoId?.intitulePoste || evt?.candidatureId?.dossierId?.nom) +
            `<br/> ${i18n.t('Réf. Besoin')}: ` + (evt?.candidatureId?.aoId?.aoId || evt?.candidatureId?.dossierId?.dossierId) +
            `<br/> ${i18n.t('Source de Candid')}: ` + searchLabelInEnumByValue(fluxCandidature, evt?.candidatureId?.flux) +
            `<br/> ${i18n.t('Statut')}: ` + searchLabelInEnumByValue(rdvStatus, evt?.statut) +
            `<br/> ${(evt?.candidatureId?.aoId?.companyDataId || evt?.candidatureId?.dossierId?.companyDataId) ? i18n.t('Nom Client'):i18n.t('Nom Esn')}: ` + (evt?.candidatureId?.aoId?.companyDataId?.profileEntreprise?.nom || evt?.candidatureId?.dossierId?.companyDataId?.profileEntreprise?.nom || evt?.candidatureId?.aoId?.esnId?.profileEntreprise?.nom||evt?.candidatureId?.dossierId?.esnId?.profileEntreprise?.nom) +
            `<br/> ${(evt?.candidatureId?.aoId?.companyDataId || evt?.candidatureId?.dossierId?.companyDataId) ? i18n.t('Réf. Client'):i18n.t('Réf. Esn')}: ` + (evt?.candidatureId?.aoId?.companyDataId?.clientId || evt?.candidatureId?.dossierId?.companyDataId?.clientId || evt?.candidatureId?.aoId?.esnId?.esnId||evt?.candidatureId?.dossierId?.esnId?.esnId) +
            `<br/> ${i18n.t('Nom Expert')}: ` + (evt ? getNomPrenomClearFromPersoData(evt?.candidatureId?.expertId?.persoData) : '') +
            `<br/> ${i18n.t('Réf. Expert')}: ` + (evt ? evt?.candidatureId?.expertId?.expertId : '') +
            `<br/> ${i18n.t('Emplacement')}: ` + (searchLabelInEnumByValue(EmplacementEnum, evt?.emplacement)) +
            `<br/> ${i18n.t('Date')}: ` + (evt?.date.split(' ')[0]));
    }
    // console.log('dayEvent',dayEvent);
    return (
        <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
            {rowIdx === 0 && (
                <div
                    style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        background: '#FFFFFF',
                        border: '1px solid #C3C9F1',
                        borderRadius: '10px 0px 0px 0px',
                        justifyContent: 'center',
                        padding: '8px',
                    }}
                >
                    <p
                        // className="text-sm mt-1 font-family:verdana"
                        style={{
                            fontSize: '0.875rem',
                            margin: 0,
                        }}
                    >
                        {device=='desktop' ?
                            day.format('dddd').toUpperCase()
                            :
                            day.format('ddd').toUpperCase()
                        }
                    </p>
                </div>
            )
            }
            <div
                className="rectangle"
            >
                <header
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    }}
                >
                    <p
                        // className={`text-sm p-1 my-1 text-center  ${getCurrentDayClass()}`}
                        style={{
                            fontFamily: 'Lato',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            fontSize: '24px',
                            lineHeight: '28px',
                            color: '#000000',
                        }}
                    >{day.format('DD')}</p>
                </header>
                <div
                    // className="flex-1 cursor-pointer"
                    style={{
                        //flex: '1 1 0%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        cursor: 'pointer',
                    }}
                >
                    {dayEvent.map((evt) => {
                        if (((evt?.statut === 'accepte' || evt?.statut === 'replanifie') && role === 'expert') ||((evt?.statut === 'accepte' || evt?.statut === 'replanifie') && role === 'esn' && evt?.readOnly)||( (evt?.statut !== 'accepte' || evt?.statut !== 'replanifie')&& role === 'esn' && !evt?.readOnly)|| role == 'client' || role=='admin') {
                            return (
                                <>
                                    <Tooltip title={<span dangerouslySetInnerHTML={{ __html: getInfoRdv(evt) }}></span>}>
                                        <div
                                            key={evt?._id}
                                            // className={statuRDV2ClassName(evt?.statut)}
                                            style={{
                                                ...statuRDV2ClassName(evt?.statut),
                                                // width: '204.2px',
                                                // height: '44px',
                                                marginright: '3px',
                                                textAlign: 'center'
                                            }}
                                            onClick={() => {
                                                setSelectedRDV(evt);
                                                setOpenNestedInterviewerCandidature(true);
                                                setShowRDV(false);
                                            }}
                                            onDoubleClick={(e) => {
                                                //   * I used event.detail to get the current click count. It's the number of time the mouse's been clicked in the same area in a short time.
                                                console.log('double click', e.detail);
                                                setOpenNestedInterviewerCandidature(true);
                                                setShowRDV(false);
                                            }}
                                            // ? 1- onHover Action reactJs pb: can't select all the elements (rdvs): like a performance pb ,
                                            // *details: I got onMouseLeave executed even before leaving ..
                                            onMouseEnter={(e) => {
                                                console.log('in', e.clientY, e.clientX, e.target.offsetLeft, e.target.offsetTop);
                                                // eslint-disable-next-line no-debugger
                                                // debugger;
                                                setSelectedRDV({
                                                    clientX: e.clientX,
                                                    clientY: e.target.offsetTop,
                                                    // clientX:e.clientX - e.target.offsetLeft,
                                                    // clientY:e.clientY - e.target.offsetTop,
                                                    ...evt
                                                });
                                                setShowRDV(true);
                                            }}
                                            onMouseLeave={() => {
                                                console.log('out');
                                                // setSelectedRDV({});
                                                setShowRDV(false);
                                            }}
                                        // ? 2- second sol
                                        // onMouseOver={() =>  {
                                        //     console.log('in 1');
                                        //     setSelectedRDV(evt);
                                        //     setShowRDV(true);
                                        // }}
                                        // onMouseOut={() =>  {
                                        //     console.log('out 1');
                                        //     setSelectedRDV({});
                                        //     setShowRDV(false);
                                        // }}
                                        >
                                            {/*<p
                                                // className="ml-1 text-gray-700"
                                                style={{margin:'0px',}}
                                            >{evt?.heureDebut} - {evt?.heureFin}</p>
                                            <p
                                                // className="ml-1 text-gray-700"
                                                style={{color: '#374151',margin:'0px',}}
                                            >{evt?.emplacement}</p>*/}
                                            <p
                                                // className="ml-1 text-gray-700"
                                                style={{
                                                    margin: '0px',
                                                    color: '#475063',
                                                    fontFamily: 'Lato',
                                                    fontStyle: 'normal',
                                                    fontWeight: '400',
                                                    fontSize: '10px',
                                                    lineHeight: '16px',
                                                }}
                                            >{evt?.heureDebut}-{evt?.heureFin}
                                                <span
                                                    style={{
                                                        margin: '0px',
                                                        fontFamily: 'Lato',
                                                        fontStyle: 'normal',
                                                        fontWeight: '400',
                                                        fontSize: '12px',
                                                        lineHeight: '16px',
                                                        color: '#272D3C'
                                                    }}
                                                > {i18n.t(searchLabelInEnumByValue(EmplacementEnum, evt?.emplacement))}</span></p>
                                        </div>
                                    </Tooltip>
                                </>
                            );
                        }
                    })}
                </div>
            </div>
        </div>
    );
}
